export default "__VITE_ASSET__0ca76c6d__"